// Author Lin
// Date 2022-07-21 15:45:14

class SithMesInventoryLiftRiggings {
    constructor({
            id = null,
            checkRecordId = '',
            riggingCode = '',
            riggingProperly = '',
            remark = ''}
    = {}) {
        this.id = id;
        this.checkRecordId = checkRecordId;
        this.riggingCode = riggingCode;
        this.riggingProperly = riggingProperly;
        this.remark = remark;
    }
    }
    
    function newEntity() {
    return new SithMesInventoryLiftRiggings();
    }
    
        function gridFields() {
        return Object.freeze([
            {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.grid.id',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            }
            },
            {
            key: 'checkRecordId',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.grid.checkRecordId',
            sortable: true,
            form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            }
            },
            {
            key: 'riggingCode',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.grid.riggingCode',
            sortable: true,
            form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            }
            },
            {
            key: 'riggingName',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.grid.riggingName',
            sortable: true,
            form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            }
            },
            {
            key: 'riggingSpecification',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.grid.riggingSpecification',
            sortable: true,
            form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            }
            },
            {
            key: 'riggingProperly',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.grid.riggingProperly',
            sortable: true,
            form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
            }
            },
            {
            key: 'createdUserName',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.grid.createdUserName',
            sortable: true,
            form: {
            type: 'input',
            modalMultiSelectedType: 'string'
            }
            },
            {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.grid.remark',
            sortable: true,
                isDetail: true,
            form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
            }
            }
        ])}
    
    const filter = {
        idFilter : '',
        idListFilter : [],
        checkRecordIdFilter : '',
        riggingCodeFilter : '',
        riggingProperlyFilter : ''
    };
    
    const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
    
    const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
    
    const filterConfigs = [
            {
            key: 'checkRecordIdFilter',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.filter.checkRecordId',
            disabled: false,
            form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
                ,entity: 'sithMesInventoryLiftCheck'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'riggingCodeFilter',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.filter.riggingCode',
            disabled: false,
            form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
                ,entity: 'emArchBasicData'
                ,correspondingField: 'code'
                    }
            },
            {
            key: 'riggingProperlyFilter',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.filter.riggingProperly',
            disabled: false,
            form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
                    }
            }
    ];
    
    
        const entityFormConfigs = [
            {
            key: 'checkRecordId',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.entity.checkRecordId',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
                ,entity: 'sithMesInventoryLiftCheck'
                ,correspondingField: 'id'
                    }
            },
            {
            key: 'riggingCode',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.entity.riggingCode',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
                ,entity: 'emArchBasicData'
                ,correspondingField: 'code'
                    }
            },
            {
            key: 'riggingProperly',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.entity.riggingProperly',
            sortable: true,
            disabled: false,
            form: {
            type: 'boolean',
            modalMultiSelectedType: 'string'
                    }
            },
            {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryLiftRiggings.entity.remark',
            sortable: true,
            disabled: false,
            form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
                    }
            }
    ]
    
    export {SithMesInventoryLiftRiggings, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs
    
    
    }
    